import { getEmploymentContractTypesInUsedRemote } from '@flex-apis/recruiting';
import { useQueryFromRemote } from '@flex-packages/remote-hooks';

function useGetEmploymentContractTypesInUsedRemote(requestParams, options) {
  return useQueryFromRemote({
    remote: getEmploymentContractTypesInUsedRemote,
    extraParams: requestParams,
    options
  });
}

export { useGetEmploymentContractTypesInUsedRemote };
//# sourceMappingURL=useGetEmploymentContractTypesInUsedRemote.mjs.map
